var map = {
	"./pixel_correct.svg": 4778,
	"./pixel_correct_center.svg": 5957,
	"./pixel_pause.svg": 2851,
	"./pixel_pause_center.svg": 1458,
	"./pixel_wrong.svg": 6547,
	"./pixel_wrong_center.svg": 964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6758;